(function () {
  'use strict';

  var MOBILE_MAX = 768;

  function primeBackgrounds(root) {
    var images = root.querySelectorAll('.tab-bg-image img');
    Array.prototype.forEach.call(images, function (img) {
      if (window.getComputedStyle(img).display === 'none') return;
      if (img.loading !== 'eager') img.loading = 'eager';
    });
  }

  function watchViewport(root) {
    if (!('IntersectionObserver' in window)) {
      primeBackgrounds(root);
      return;
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) primeBackgrounds(root);
        });
      },
      { rootMargin: '400px' }
    );
    observer.observe(root);
  }

  function init(root) {
    if (root.dataset.tabBgReady) return;
    root.dataset.tabBgReady = 'true';

    var buttons = Array.prototype.slice.call(root.querySelectorAll('.tab-button'));
    if (!buttons.length) return;

    var strip = root.querySelector('.tab-buttons');
    var layers = Array.prototype.slice.call(root.querySelectorAll('.tab-bg-slide'));
    var carouselRoot = root.querySelector('.tab-contents-wrapper');
    var slides = carouselRoot
      ? Array.prototype.slice.call(carouselRoot.querySelectorAll('.swiper-slide'))
      : [];

    watchViewport(root);

    function centreTab(button) {
      if (!strip || window.innerWidth >= MOBILE_MAX) return;
      var limit = strip.scrollWidth - strip.clientWidth;
      var target = button.offsetLeft - (strip.clientWidth - button.offsetWidth) / 2;
      strip.scrollTo({
        left: Math.max(0, Math.min(target, limit)),
        behavior: 'smooth'
      });
    }

    function paint(index) {
      buttons.forEach(function (button, i) {
        button.classList.toggle('active', i === index);
      });
      layers.forEach(function (layer, i) {
        layer.classList.toggle('is-active', i === index);
      });
      slides.forEach(function (slide, i) {
        slide.classList.toggle('swiper-slide-active', i === index);
      });
      centreTab(buttons[index]);
    }

    /*
      Loop only when there are more cards than fit in the widest view (2.1).
      Flickity's wrapAround needs the cards to be wider than the carousel in
      total; with just two cards it shifted them around on a tab switch (the
      first card jumped to the middle with the second cut off at the edge).
    */
    var MAX_PER_VIEW = 2.1;

    var carousel =
      carouselRoot && typeof window.themeCarousel === 'function'
        ? window.themeCarousel(carouselRoot, {
            slidesPerView: 1.2,
            spaceBetween: 20,
            loop: slides.length > MAX_PER_VIEW,
            breakpoints: {
              0: {
                slidesPerView: 1.2,
                spaceBetween: 12
              },
              768: {
                slidesPerView: MAX_PER_VIEW
              },
              1024: {
                slidesPerView: MAX_PER_VIEW
              }
            }
          })
        : null;

    function normalise(index) {
      return ((index % buttons.length) + buttons.length) % buttons.length;
    }

    buttons.forEach(function (button, index) {
      button.addEventListener('click', function () {
        if (carousel) carousel.select(index, true);
        paint(index);
      });
    });

    if (carousel) {
      carousel.on('select', function () {
        paint(normalise(carousel.selectedIndex));
      });
    }

    paint(0);
  }

  function start() {
    Array.prototype.forEach.call(document.querySelectorAll('.custom-tab-bg'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
